import ModalServiceClass from './modal.service';
import StellarServiceClass from './stellar.service';
import WalletConnectServiceClass from './wallet-connect.service';
import ToastServiceClass from './toast.service';
import LedgerServiceClass from './ledger.service';

export const ModalService = new ModalServiceClass();
export const StellarService = new StellarServiceClass();
export const WalletConnectService = new WalletConnectServiceClass();
export const ToastService = new ToastServiceClass();
export const LedgerService = new LedgerServiceClass();
